import { useQuery } from "@apollo/client";
import { getFragmentData, graphql } from "../gql";
import { OnboardingLiveFragment } from "./OnboardingLiveFragments.ts";
import { OnboardingLiveListPeriod } from "../gql/graphql.ts";

export const GetOnboardingLivesQuery = graphql(`
  query getOnboardingLives(
    $period: OnboardingLiveListPeriod!
    $userGroupId: String
    $teacherId: String
  ) {
    getOnboardingLives(
      period: $period
      userGroupId: $userGroupId
      teacherId: $teacherId
    ) {
      ...OnboardingLiveItem
    }
  }
`);

export function useOnboardingLives({
  period,
  userGroupId,
  teacherId,
}: {
  period: OnboardingLiveListPeriod;
  userGroupId?: string;
  teacherId?: string;
}) {
  const { data, loading } = useQuery(GetOnboardingLivesQuery, {
    variables: { period, userGroupId, teacherId },
    fetchPolicy: "cache-and-network",
  });
  return {
    onboardingLives:
      getFragmentData(OnboardingLiveFragment, data?.getOnboardingLives) ?? [],
    loading,
  };
}
